import { h } from "preact";
import { useState } from "preact/hooks";

import i18n from "../i18n.js";

import Button from "./Button.jsx";
import Icon from "./Icon.jsx";
import ListItem from "./ListItem.jsx";

export default function CopyableLink({ highlight, name, value }) {
  const [showCopyNote, setShowCopyNote] = useState(false);

  function handleClick() {
    navigator.clipboard.writeText(value);
    setShowCopyNote(true);
    setTimeout(() => {
      setShowCopyNote(false);
    }, 1500);
  }

  return (
    <ListItem
      highlight={highlight}
      secondLine={
        showCopyNote ? i18n.t("component.copyable_link.copy_note") : value
      }
      oneLine
      iconBack={
        <Button trackingName="shareLink.copy" text onClick={handleClick}>
          <Icon>content_copy</Icon>
        </Button>
      }
    >
      {name}
    </ListItem>
  );
}
